import { trackStructEvent } from "@rtl_nl/rtl-snowplow";
import { globalVars } from "./variables";

/**
 *
 */
function initFooterTracking() {
    // regular footer links
    for (const footerLink of document.querySelectorAll(
        ".vl-footer .menu-item a"
    )) {
        const text = footerLink.innerText;
        footerLink.addEventListener("click", () => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "navigation",
                action: "footer",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "footer",
                    elementType: "button",
                    elementName: "footer",
                    elementLabel: text,
                },
            });
        });
    }

    // social media icons
    for (const footerLink of document.querySelectorAll(
        ".vl-footer a.social-link"
    )) {
        footerLink.addEventListener("click", () => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "navigation",
                action: "footer",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "footer",
                    elementType: "button",
                    elementName: "social-media"
                },
            });
        });
    }

    // login button
    document
        .querySelector(".vl-footer a.vl-loggedin-hide")
        .addEventListener("click", () => {
            trackStructEvent({
                appId: globalVars.app_id,
                category: "navigation",
                action: "footer",
                rtlElementContext: {
                    elementInteraction: "click",
                    elementGroup: "footer",
                    elementType: "button",
                    elementName: "login",
                    elementLabel: "Inloggen"
                },
            });
        });
}

export { initFooterTracking };
